import {
  Image,
  Box,
  Heading,
  Container,
  Text,
  Button,
  HStack,
  Stack,
} from '@chakra-ui/react';
import cusdLogo from '../images/cusd-48.svg';
import bnbLogo from '../images/bnb-48.svg';

export default function Hero() {
  return (
    <>
      <Container maxW={'4xl'}>
        <Stack
          as={Box}
          textAlign={'center'}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 20, md: 36 }}>
          <Heading
            as='h1'
            fontWeight={600}
            fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
            lineHeight={'110%'}
            alignSelf='center'>
            <HStack wrap='wrap'>
            <Text>Mint</Text>
              <HStack>
                <Image src={cusdLogo}/>
                <Text>CUSD</Text>
              </HStack>
              <Text>against</Text>
              <HStack>
                <Image src={bnbLogo}/>
                <Text>BNB</Text>
              </HStack>
            </HStack>
          </Heading>
          <Heading size='lg' color={'gray.500'}>
            Governance-free stablecoin<br />
            <Text as={'span'} color={'yellow.400'}>
              &nbsp;0%&nbsp;
            </Text>
            interest loans<br />
            <Text as={'span'} color={'yellow.400'}>
              &nbsp;$100&nbsp;
            </Text>
            position threshold<br />
          </Heading>
          <HStack
            direction={'column'}
            spacing={3}
            align={'center'}
            alignSelf={'center'}
            position={'relative'}>
            <a href='https://crangon.web.app/'>
            <Button
              size='lg'
              height='80px'
              width='240px'
              fontSize='24px'
              colorScheme={'yellow'}
              bg={'yellow.400'}
              _hover={{
                bg: 'yellow.500',
              }}>
              Launch App
            </Button>
            </a>
          </HStack>
        </Stack>
      </Container>
    </>
  );
}
